import GameScene from "../scenes/GameScene";

export default class ItemIndicator extends PIXI.Container {
    constructor() {
        super();

        this._tweens = [];

        this.init();
    }

    init() {
    }

    destroy() {
        this._removeTweens();

        super.destroy({ children: true });
    }

    /**
     * @param {Item} item
     * @param {number} [delay=0]
     * @return {Promise}
     */
    animateCollect(item, delay = 0) {
        return new Promise((resolve) => {
            const icon = new PIXI.Sprite(item.texture);
            icon.anchor.set(0.5);
            icon.scale.set(0);
            icon.visible = false;
            this.addChild(icon);

            const tween = gsap.timeline({
                onComplete: () => {
                    this._removeTween(tween);
                    resolve(icon);
                }
            });
            GameScene.active.addTween(tween);

            tween.add(gsap.to(icon.scale, 0.24, {
                delay: 0.1 + delay,
                x: 1,
                y: 1,
                ease: "back.out(2.4)",
                onStart: () => icon.visible = true
            }));
            tween.add(gsap.delayedCall(0.35, () => {}));
            this._tweens.push(tween);
        });
    }

    /**
     * @param {gsap.core.Tween|gsap.core.Timeline} tween
     * @return {boolean}
     * @private
     */
    _removeTween(tween) {
        const i = this._tweens.indexOf(tween);
        if (i >= 0) {
            this._tweens[i].kill();
            this._tweens.splice(i, 1);
            return true;
        }
        return false;
    }

    /**
     * @private
     */
    _removeTweens() {
        for (let i = 0, count = this._tweens.length; i < count; ++i) {
            const tween = this._tweens[i];
            tween.kill();
        }
        this._tweens.length = 0;
    }
}